import { PureComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';

const Container = styled.div`
  font-size: 14px;
  padding: 0 0 2px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.5;
`;

const StyledLabel = styled('label')`
  text-transform: uppercase;
`;

interface ILabelTextProps {
  helpText?: string
  htmlFor?: string 
  children?: ReactNode
}

class LabelText extends PureComponent<ILabelTextProps> {
  render() {
    return (
      <Container>
        <StyledLabel htmlFor={this.props.htmlFor}>
          {this.props.children}
        </StyledLabel>
        <Box>{this.props.helpText}</Box>
      </Container>
    );
  }
}

export default LabelText;